import React from 'react';
import { ScrollReveal } from '../components/ScrollReveal';
const steps = [{
  num: '01',
  title: 'Discovery',
  desc: 'We learn about your brand, goals, and audience.'
}, {
  num: '02',
  title: 'Strategy',
  desc: 'We develop a tailored plan designed to achieve results.'
}, {
  num: '03',
  title: 'Creation',
  desc: 'We produce high-quality, on-brand content.'
}, {
  num: '04',
  title: 'Execution',
  desc: 'We launch, manage, and optimize your content.'
}, {
  num: '05',
  title: 'Growth',
  desc: 'We refine and evolve based on performance.'
}];
export function ProcessPage() {
  return <div className="w-full pt-32 pb-32 px-6 md:px-12" data-id="element-282">
      <div className="max-w-4xl mx-auto" data-id="element-283">
        <ScrollReveal className="text-center mb-24" data-id="element-284">
          <h1 className="text-5xl md:text-7xl font-heading font-bold text-teal mb-6" data-id="element-285">
            How We Work Together
          </h1>
          <p className="text-xl text-teal/80" data-id="element-286">
            A clear, collaborative process.
          </p>
        </ScrollReveal>

        <div className="relative" data-id="element-287">
          {/* Vertical Line for Desktop */}
          <div className="hidden md:block absolute left-[50px] top-0 bottom-0 w-0.5 bg-teal/10" data-id="element-288" />

          <div className="space-y-12 md:space-y-20" data-id="element-289">
            {steps.map((step, index) => <ScrollReveal key={step.num} delay={index * 0.1} data-id="element-290">
                <div className="relative flex flex-col md:flex-row gap-6 md:gap-16 items-start group" data-id="element-291">
                  {/* Number Indicator */}
                  <div className="relative z-10 flex items-center justify-center w-24 h-24 rounded-full bg-white shadow-sm border border-sage/30 shrink-0 group-hover:border-coral transition-colors duration-500" data-id="element-292">
                    <span className="text-3xl font-heading font-bold text-coral" data-id="element-293">
                      {step.num}
                    </span>
                  </div>

                  {/* Content Card */}
                  <div className="flex-1 bg-white/40 backdrop-blur-sm rounded-3xl p-8 md:p-10 border border-white/60 hover:bg-white/60 transition-colors duration-500 mt-2 md:mt-0" data-id="element-294">
                    <h2 className="text-3xl font-heading font-bold text-teal mb-4" data-id="element-295">
                      {step.title}
                    </h2>
                    <p className="text-xl text-teal/70" data-id="element-296">{step.desc}</p>
                  </div>
                </div>
              </ScrollReveal>)}
          </div>
        </div>
      </div>
    </div>;
}